import { WrapperSection as r } from "./section.js";
import { DividedSection as p } from "./divided-section.js";
export {
  p as DividedSection,
  r as WrapperSection
};
